import { render, staticRenderFns } from "./templateCard.vue?vue&type=template&id=0ba57562&scoped=true"
import script from "./templateCard.vue?vue&type=script&lang=js"
export * from "./templateCard.vue?vue&type=script&lang=js"
import style0 from "./templateCard.vue?vue&type=style&index=0&id=0ba57562&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba57562",
  null
  
)

export default component.exports